import { FormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/FormItem';
import { MinimalFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/MinimalFormItem';

export const getTotalPrice = (item: MinimalFormItem | FormItem): number => {
  let totalPrice = parseInt(item.units) * parseFloat(item.price || '0');
  if (isNaN(totalPrice)) totalPrice = 0;
  return totalPrice;
};
